import { HttpClient } from '@/shared';
import { PartnerPrefill } from '../../application/domain/entities/PartnerPrefill';
import { IPartnerPrefillRepository } from '../../application/ports/outbound/IPartnerPrefillRepository';
import { PartnerPrefillResponseDto } from './dto/res/PartnerPrefillResponseDto';

/**
 * Candidate prefill for a partner-originated Section 1 (VTK-1918).
 *
 * POST, not GET, so the capability token rides the body: a query-string token would land in gateway
 * access logs and browser history. Nothing here is logged, stored or echoed anywhere but the form
 * fields themselves.
 */
export class ApiPartnerPrefillRepository implements IPartnerPrefillRepository {
  constructor(private readonly httpClient: HttpClient) {}

  async fetchPrefill(token: string): Promise<PartnerPrefill> {
    const response = await this.httpClient.post<PartnerPrefillResponseDto>(
      '/partner/section1-prefill',
      { token }
    );
    // Read field by field rather than spreading the body: a payload that grows a key we do not
    // expect (an SSN, a citizenship status) must not become a form value by accident.
    const values = response.data?.prefill;
    return {
      values: {
        firstName: values?.firstName ?? null,
        middleName: values?.middleName ?? null,
        lastName: values?.lastName ?? null,
        otherLastNames: values?.otherLastNames ?? null,
        email: values?.email ?? null,
        employmentStartDate: values?.employmentStartDate ?? null,
        phone: values?.phone ?? null,
        address: values?.address
          ? {
              line1: values.address.line1 ?? null,
              line2: values.address.line2 ?? null,
              city: values.address.city ?? null,
              state: values.address.state ?? null,
              zipCode: values.address.zipCode ?? null,
            }
          : undefined,
        location: values?.location
          ? {
              locationId: values.location.locationId ?? null,
              locationName: values.location.locationName ?? null,
              locked: values.location.locked,
            }
          : undefined,
      },
    };
  }
}

export default ApiPartnerPrefillRepository;
